import { render, staticRenderFns } from "./TagsMarketing.vue?vue&type=template&id=628cb0e2&scoped=true"
import script from "./TagsMarketing.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsMarketing.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TagsMarketing.vue?vue&type=style&index=0&id=628cb0e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628cb0e2",
  null
  
)

export default component.exports